import { z } from 'zod';

export const accountInformationSchema = z
  .object({
    token: z.string().min(1, 'Token is required'),
    tokenBalance: z.string().min(1, 'Token balance is required'),
    usdBalance: z.string().min(1, 'USD balance is required'),
    includeInitialPerpetual: z.boolean(),
    initialPerpetualBalance: z.string(),
  })
  .superRefine((data, ctx) => {
    if (data.includeInitialPerpetual && !data.initialPerpetualBalance.trim()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['initialPerpetualBalance'],
        message: 'Initial perpetual balance is required',
      });
    }
  });

export type AccountInformationSchemaType = z.infer<typeof accountInformationSchema>;
